import { render } from "./AmountNumber.vue?vue&type=template&id=846094e0&scoped=true"
import script from "./AmountNumber.vue?vue&type=script&lang=js"
export * from "./AmountNumber.vue?vue&type=script&lang=js"

import "./AmountNumber.vue?vue&type=style&index=0&id=846094e0&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-846094e0"]])

export default __exports__